var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar brdr-1 brdr-cl-primary bg-cl-white p20" },
    [
      _c("div", { staticClass: "h4 sidebar__header relative mt0 mb20 flex" }, [
        _c("span", [_vm._v(" " + _vm._s(_vm.$t("Filter")) + " ")]),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasActiveFilters,
                expression: "hasActiveFilters"
              }
            ],
            staticClass:
              "weight-400 sidebar__header__clear pointer sans-serif flex lh25",
            on: { click: _vm.resetAllFilters }
          },
          [
            _c("i", { staticClass: "material-icons cl-accent mr5" }, [
              _vm._v("\n        cancel\n      ")
            ]),
            _vm._v("\n      " + _vm._s(_vm.$t("Clear filters")) + "\n    ")
          ]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.availableFilters, function(filter, filterIndex) {
        return _c("div", { key: filterIndex }, [
          _c("div", { staticClass: "h5 sidebar__header-option" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t(filterIndex + "_filter")) + "\n    "
            )
          ]),
          _vm._v(" "),
          filterIndex === "kolor"
            ? _c(
                "div",
                _vm._l(_vm.sortByLabel(filter), function(color, index) {
                  return _c("color-selector", {
                    key: index,
                    attrs: {
                      context: "category",
                      code: "kolor",
                      variant: color,
                      "selected-filters": _vm.getCurrentFilters
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("changeFilter", $event)
                      }
                    }
                  })
                }),
                1
              )
            : filterIndex === "producent_oem"
            ? _c(
                "div",
                _vm._l(_vm.sortByLabel(filter), function(item, index) {
                  return _c("list-selector", {
                    key: index,
                    attrs: {
                      context: "category",
                      code: "producent_oem",
                      variant: item,
                      "selected-filters": _vm.getCurrentFilters
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("changeFilter", $event)
                      }
                    }
                  })
                }),
                1
              )
            : filterIndex === "size"
            ? _c(
                "div",
                _vm._l(_vm.sortById(filter), function(size, index) {
                  return _c("size-selector", {
                    key: index,
                    staticClass: "size-select mr10 mb10",
                    attrs: {
                      context: "category",
                      code: "size",
                      variant: size,
                      "selected-filters": _vm.getCurrentFilters
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("changeFilter", $event)
                      }
                    }
                  })
                }),
                1
              )
            : filterIndex === "price"
            ? _c(
                "div",
                _vm._l(filter, function(price, index) {
                  return _c("price-selector", {
                    key: index,
                    staticClass: "price-select mb10 block",
                    attrs: {
                      context: "category",
                      code: filterIndex,
                      id: price.id,
                      from: price.from,
                      to: price.to,
                      content: price.label,
                      variant: price,
                      "selected-filters": _vm.getCurrentFilters
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("changeFilter", $event)
                      }
                    }
                  })
                }),
                1
              )
            : filterIndex === "is_available"
            ? _c(
                "div",
                [
                  _c("boolean-selector", {
                    staticClass: "mr10 mb10 block sidebar__inline-selecors",
                    attrs: {
                      context: "category",
                      code: filterIndex,
                      variant: filter[0],
                      "selected-filters": _vm.getCurrentFilters
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("changeFilter", $event)
                      }
                    }
                  })
                ],
                1
              )
            : filterIndex === "is_suggested"
            ? _c(
                "div",
                [
                  _c("boolean-selector", {
                    staticClass: "mr10 mb10 block sidebar__inline-selecors",
                    attrs: {
                      context: "category",
                      code: filterIndex,
                      variant: filter[0],
                      "selected-filters": _vm.getCurrentFilters
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("changeFilter", $event)
                      }
                    }
                  })
                ],
                1
              )
            : filterIndex === "is_new_product"
            ? _c(
                "div",
                [
                  _c("boolean-selector", {
                    staticClass: "mr10 mb10 block sidebar__inline-selecors",
                    attrs: {
                      context: "category",
                      code: filterIndex,
                      variant: filter[0],
                      "selected-filters": _vm.getCurrentFilters
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("changeFilter", $event)
                      }
                    }
                  })
                ],
                1
              )
            : filterIndex === "is_promotion"
            ? _c(
                "div",
                [
                  _c("boolean-selector", {
                    staticClass: "mr10 mb10 block sidebar__inline-selecors",
                    attrs: {
                      context: "category",
                      code: filterIndex,
                      variant: filter[0],
                      "selected-filters": _vm.getCurrentFilters
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("changeFilter", $event)
                      }
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "sidebar__inline-selecors" },
                _vm._l(filter, function(option, index) {
                  return _c("generic-selector", {
                    key: index,
                    staticClass: "mr10 mb10 block",
                    attrs: {
                      context: "category",
                      code: filterIndex,
                      variant: option,
                      "selected-filters": _vm.getCurrentFilters
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("changeFilter", $event)
                      }
                    }
                  })
                }),
                1
              )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }